export enum TipoDocumentoMedsusEnum {
  NAO_INFORMADO,
  DOCUMENTO,
  EXAME,
}

// Mapeamento para exibição amigável
export const TipoDocumentoMedsusLabels: Record<
  TipoDocumentoMedsusEnum,
  string
> = {
  [TipoDocumentoMedsusEnum.NAO_INFORMADO]: 'Não informado',
  [TipoDocumentoMedsusEnum.DOCUMENTO]: 'Documento',
  [TipoDocumentoMedsusEnum.EXAME]: 'Exame',
};

// Mapeamento para códigos/slugs (se necessário para URLs, etc.)
export const TipoDocumentoMedsusCodes: Record<TipoDocumentoMedsusEnum, string> =
  {
    [TipoDocumentoMedsusEnum.NAO_INFORMADO]: 'NI',
    [TipoDocumentoMedsusEnum.DOCUMENTO]: 'D',
    [TipoDocumentoMedsusEnum.EXAME]: 'E',
  };

export const getTipoDocumentoMedsusOptions = () => {
  return Object.values(TipoDocumentoMedsusEnum)
    .filter((value) => typeof value === 'number')
    .map((value) => ({
      value: value as TipoDocumentoMedsusEnum,
      label: TipoDocumentoMedsusLabels[value as TipoDocumentoMedsusEnum],
      code: TipoDocumentoMedsusCodes[value as TipoDocumentoMedsusEnum],
    }));
};

export const getTipoDocumentoMedsusLabel = (
  tipoDocumentoMedsus: TipoDocumentoMedsusEnum,
): string => {
  return (
    TipoDocumentoMedsusLabels[tipoDocumentoMedsus] || 'Status Desconhecido'
  );
};

export const getTipoDocumentoMedsusSlug = (
  tipoDocumentoMedsus: TipoDocumentoMedsusEnum,
): string => {
  return TipoDocumentoMedsusCodes[tipoDocumentoMedsus] || 'Desconhecido';
};

export const getTipoDocumentoMedsusPorCodigo = (
  code: string,
): TipoDocumentoMedsusEnum | undefined => {
  const entry = Object.entries(TipoDocumentoMedsusCodes).find(
    ([, value]) => value === code,
  );
  return entry ? (Number(entry[0]) as TipoDocumentoMedsusEnum) : undefined;
};

export const getTipoDocumentoMedsusSlugPorValue = (
  value: number | string,
): string => {
  const numericValue = typeof value === 'string' ? Number(value) : value;
  return (
    TipoDocumentoMedsusCodes[numericValue as TipoDocumentoMedsusEnum] ||
    'Desconhecido'
  );
};

export const getTipoDocumentoMedsusLabelPorSlug = (slug: string): string => {
  const entry = Object.entries(TipoDocumentoMedsusCodes).find(
    ([, value]) => value === slug,
  );
  if (entry) {
    const key = Number(entry[0]) as TipoDocumentoMedsusEnum;
    return TipoDocumentoMedsusLabels[key] || 'Não informado';
  }
  return 'Não informado';
};
